import Modal from "../../../components/Modal/Modal";
import React, { useState, useEffect } from "react";
import { useApp } from "../../../contexts";
import styled from "styled-components";
import { getCookie } from "../../../utils/helper";
import FormButton from "../../../components/FormCustom2/Button";
import ReactFlagsSelect from "react-flags-select";
import { useWindowSize } from "../../../hook/useWindowSize";
import { PHONE_CODES } from "../../../constants";
import { IconSuccess } from "../../../components/Icons/IconSuccess";
import {
  ssoVerifyPhoneRequest,
  ssoVerifyPhoneConfirm,
} from "../../../services/app";
import { initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier } from "firebase/auth";
import environment from "../../../environment";
const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const OTP_TIME = 90;
export const ModalVerifyPhone = ({ value, ...props }) => {
  const appOptions = {
    apiKey: environment.FIREBASE_API_KEY,
  };
  // if (environment.FIREBASE_AUTH_DOMAIN) {
  //   appOptions.authDomain = environment.FIREBASE_AUTH_DOMAIN;
  // }
  const app = initializeApp(appOptions);
  const { T: t, language } = useApp();
  const size = useWindowSize();
  const isMobile = size.width <= 1024 ? true : false;
  const ssoDataStr = getCookie(environment.AUTH_COOKIE_KEY);
  const ssoData =
    typeof ssoDataStr == "object" ? ssoDataStr : JSON.parse(ssoDataStr || "{}");
  const { open, countryCode, handleClickClose, onFinishVerify } = props;
  const [step, $setStep] = useState(props.type == 2 ? 2 : 1);
  const [otpCountdown, $otpCountdown] = useState(OTP_TIME);
  const [isSendingOtp, $isSendingOtp] = useState(false);
  const [countSend, $countSend] = useState(0);
  const [inputPlaceHolder, $inputPlaceHolder] = useState(
    t("title.verification_holder")
  );
  const [state, $state] = useState({
    countryCode: countryCode,
    phone: "",
    verifyCode: "",
  });

  const [phoneMessage, $phoneMessage] = useState("");
  const [otpMessage, $otpMessage] = useState("");
  const [recaptchaToken, $recaptchaToken] = useState("");

  const stopTimer = () => {
    if (timerOtp) {
      clearInterval(timerOtp);
      timerOtp = null;
    }
  };
  const closeModal = () => {
    setTimeout(function () {
      handleClickClose();
      resetState();
    }, 100);
  };
  const goStep = (s) => {
    $setStep(s);
  };
  const setCountryCode = (val) => {
    $state((preVal) => ({ ...preVal, countryCode: val }));
  };
  const onChangePhoneNumber = (val) => {
    $state((preVal) => ({ ...preVal, phone: val }));
  };
  const changeVerifyCode = (val) => {
    $state((preVal) => ({ ...preVal, verifyCode: val }));
  };

  const resetState = () => {
    // reset state
    $setStep(props.type == 2 ? 2 : 1);
    $phoneMessage("");
    $otpMessage("");
    $countSend(0);
    $state({
      countryCode: countryCode,
      phone: "",
      verifyCode: "",
    });
    $otpCountdown(OTP_TIME);
    $isSendingOtp(false);
    stopTimer();
  };

  const handleSendCode = () => {
    changeVerifyCode("");
    $otpMessage("");
    if (!validateSendCode() || isSendingOtp) return;
    $otpCountdown(OTP_TIME);
    $isSendingOtp(() => {
      if (isSendingOtp) return true;
      verifyCaptcha();
      return true;
    });
  };

  const verifyCaptcha = async () => {
    try {
      const result = await window.recaptchaVerifier.verify();
      $recaptchaToken(result);
      sendCode(result);
    } catch (error) {
      sendCode(recaptchaToken);
    }
  };

  const validateSendCode = () => {
    if (!state?.phone) {
      $phoneMessage(t("title.phone_number_required"));
      return;
    }
    if (!state?.countryCode) {
      $phoneMessage(t("title.phone_number_required"));
      return;
    }
    $phoneMessage("");
    return true;
  };

  const sendCode = (recaptcha_token) => {
    const requestData = {
      country_code: state.countryCode,
      phone_code: PHONE_CODES[state.countryCode],
      phone_number: state.phone,
      recaptcha_token: recaptcha_token,
      accessToken: ssoData.access_token,
    };
    ssoVerifyPhoneRequest(requestData, language)
      .then((res) => {
        if (res.code == -1) {
          $phoneMessage(t("msg_phone_already"));
          $isSendingOtp(false);
          stopTimer();
        } else if (!res.status) {
          $phoneMessage(res.message || t("title.request_verify_fail"));
          $isSendingOtp(false);
          stopTimer();
        } else {
          // $isSendingOtp(true)
          $countSend((val) => val + 1);
        }
      })
      .catch((err) => {
        console.log("ERROR", err);
        $isSendingOtp(false);
        stopTimer();
        $phoneMessage(t("title.request_verify_fail"));
      });
  };

  const handlePhoneConfirmOtp = async () => {
    if (otpCountdown <= 0 || !state?.verifyCode) return;
    try {
      const resVerify = await ssoVerifyPhoneConfirm(
        { verify_code: state.verifyCode, accessToken: ssoData.access_token },
        language
      );
      if (!resVerify.status) {
        $otpMessage(t(resVerify.message) || t("title.request_verify_fail"));
        return;
      } 
      //   const resSyncInfo = await AccountService.syncInfo(ssoData.access_token);

      let phoneNumber = state.phone;
      if (phoneNumber.startsWith("0") && state.countryCode == "VN") {
        phoneNumber = phoneNumber.substring(1);
      }
      if (phoneNumber.indexOf("-") > -1) {
        phoneNumber = phoneNumber.replace(/\-/g, "");
      }

      const dispathData = {
        verifyPhoneStatus: resVerify?.status,
        countryCode: state.countryCode,
        verifyPhone: resVerify?.phone || phoneNumber,
      };
      onFinishVerify(dispathData);
      goStep(3);
    } catch (err) {
      console.log("ERROR", err);
      $otpMessage(err.message || t("title.phone_verify_fail"));
    }
  };
  let timerOtp;
  const countDown = () => {
    if (timerOtp) {
      clearInterval(timerOtp);
    }
    timerOtp = setInterval(() => {
      $otpCountdown((val) => {
        const newVal = val - 1;
        if (newVal <= 0) {
          clearInterval(timerOtp);
          timerOtp = null;
          $isSendingOtp(false);
        }
        return newVal;
      });
    }, 1000);
  };
  useEffect(() => {
    if (isSendingOtp) {
      countDown();
    }
  }, [isSendingOtp]);

  useEffect(() => {
    if (countSend == 0) {
      $inputPlaceHolder(t("title.verification_holder"));
    } else {
      if (otpCountdown > 0) {
        $inputPlaceHolder(t("title.verification_holder_code"));
      } else {
        $inputPlaceHolder(t("title.verification_holder_resend"));
      }
    }
  }, [otpCountdown, countSend, isSendingOtp]);
  useEffect(() => {
    $setStep(props.type == 2 ? 2 : 1);
  }, [props.type]);

  useEffect(() => {
    resetState();

    // if(!countryCode) {
    //     ip().then(res => {
    //         setCountryCode(res.data?.data?.country)
    //     })
    // }
    const auth = getAuth(app);
    window.recaptchaVerifier = new RecaptchaVerifier(
      "getotp",
      {
        size: "invisible",
        callback: (response) => {
          console.log("useEffect=>recaptchaVerifier=", response);
          return response;
        },
        "expired-callback": () => {
          console.log("useEffect=>recaptchaVerifier=>expired-callback");
        },
      },
      auth
    );
  }, []);

  return (
    <Modal onClose={closeModal}>
      <Modal.ModalBg2 onClose={closeModal} />
      <Modal.Container2 width="850px" onClose={closeModal}>
        <ContentWaper>
          {step == 1 && (
            <div
              className={`rounded-[32px] lg:rounded-[64px] w-[850px] max-w-full  mx-auto relative transition ease-in-out`}
            >
              <div className="pb-6 lg:pb-[47px]">
                <p className="text-[24px] text-center text-aia-red mb-[26px] lg:mb-[34px] font-bold h-[29px]">
                  {t("title.phone_verification")}
                </p>
                <p className="text-black text-center">
                  {t("title.phone_verification_des")}
                </p>
                {!isMobile && (
                  <p className="text-black text-center">
                    {t("title.phone_verification_des2")}
                  </p>
                )}
              </div>
              <div className="flex justify-center items-center pt-0 lg:pt-12 gap-[15px] flex-col sm:flex-row lg:border-t lg:border-solid lg:border-black/[0.1]">
                <button
                  className="w-full sm:w-40 h-[52px] px-5 py-4 bg-white text-black border border-solid border-black text-center rounded-[15px]"
                  onClick={closeModal}
                >
                  {t("Back")}
                </button>
                <button
                  className="w-full sm:w-40 h-[52px] px-5 py-4 bg-black text-white text-center rounded-[15px]"
                  onClick={() => goStep(2)}
                >
                  {t("title.continue")}
                </button>
              </div>
            </div>
          )}
          {step == 2 && (
            <div
              className={`rounded-[32px] lg:rounded-[64px] w-[850px] max-w-full  mx-auto relative transition ease-in-out`}
            >
              <div className="pb-[26px] lg:pb-[43px]">
                <p className="text-[24px] text-center text-aia-red font-bold h-[29px]">
                  {t("title.phone_verification")}
                </p>
              </div>

              <div className="flex items-center justify-center lg:justify-start max-w-full w-[486px] mx-auto lg:w-full mb-[25px] lg:mb-[30px] flex-col lg:flex-row">
                <label
                  htmlFor="form_verify_phone"
                  className="text-black w-full lg:w-[197px] lg:flex-none block pb-1 lg:pb-0"
                >
                  {t("title.phone_number")}
                </label>
                <div className="w-full">
                  <div className="p-[1px] rounded-[10px] relative max-w-full w-[486px]">
                    <input
                      id="form_verify_phone"
                      type="tel"
                      pattern="[0-9]*"
                      noValidate
                      className="h-[52px] max-w-full w-[486px] 
                                pl-28 lg:pl-[135px] pr-5 py-3 bg-white rounded-[8px] text-black input-gradient appearance-none border border-solid border-[#ddd]"
                      placeholder={t(
                        isMobile
                          ? "title.phone_number_placehoder_mb"
                          : "title.phone_number_required"
                      )}
                      value={state?.phone}
                      onChange={(e) => onChangePhoneNumber(e.target.value)}
                    />
                    <div className="bg-mark"></div>
                    <div className="absolute left-px top-px z-10 flex items-center justify-between">
                      <ReactFlagsSelect
                        className="flag-country"
                        selected={state?.countryCode}
                        onSelect={(code) => setCountryCode(code)}
                        customLabels={PHONE_CODES}
                        searchable
                        // disabled={props.type == 2 ? true : false}
                      />
                      {props.type !== 2 && (
                        <span className="h-[39px] w-[1px] bg-black/[0.1]"></span>
                      )}
                    </div>
                  </div>
                  {phoneMessage && (
                    <p className="text-suzu-error text-xs py-2">
                      {phoneMessage}
                    </p>
                  )}
                </div>
              </div>
              <div className="flex lg:items-center justify-center lg:justify-start max-w-full w-[486px] mx-auto lg:w-full mb-[25px] lg:mb-[30px] flex-col lg:flex-row">
                <label
                  htmlFor="form_verify_code"
                  className="text-black w-full lg:w-[197px] lg:flex-none block pb-1 lg:pb-0"
                >
                  {t("title.verification_code")}
                </label>
                <div className="w-full">
                  <div className="p-[1px] rounded-[10px] relative max-w-full w-[486px]">
                    <input
                      id="form_verify_code"
                      type="tel"
                      maxLength="6"
                      pattern="[0-9]{6}"
                      className="h-[52px] max-w-full w-[486px]  border border-solid border-[#ddd] pl-5 pr-32 py-3 bg-white rounded-[8px] text-black input-gradient appearance-none"
                      placeholder={inputPlaceHolder}
                      value={state?.verifyCode}
                      onChange={(e) => changeVerifyCode(e.target.value)}
                    />
                    <div className="bg-mark"></div>
                    {/* {countSend == 3 && !isSendingOtp && (
                      <button
                        className="absolute right-px top-px h-[50px] z-10 px-5 text-aia-red"
                        onClick={handleSkip}
                      >
                        {t("Skip")}
                      </button>
                    )} */}
                    {countSend < 3 && !isSendingOtp && (
                      <button
                        className="absolute right-px top-px h-[50px] z-10 px-5 text-aia-red"
                        onClick={() => handleSendCode()}
                      >
                        {t(countSend > 0 ? "Resend" : "Send Code")}
                      </button>
                    )}
                    {countSend <= 3 && isSendingOtp && (
                      <button className="absolute right-px top-px h-[50px] z-10 px-5 text-aia-red">{`${otpCountdown}s`}</button>
                    )}
                  </div>
                  {otpMessage && (
                    <p className="text-suzu-error text-xs py-2">{otpMessage}</p>
                  )}
                </div>
              </div>

              <div className="flex justify-center items-center pt-0 lg:pt-12 gap-[15px] flex-col-reverse sm:flex-row lg:border-t lg:border-solid lg:border-black/[0.1]">
                <button
                  className="w-full sm:w-40 h-[52px] px-5 py-4 bg-white text-black border border-solid border-black text-center rounded-[15px]"
                  onClick={closeModal}
                >
                  {t("Back")}
                </button>
                <button
                  className="w-full sm:w-40 h-[52px] px-5 py-4 bg-black text-white text-center rounded-[15px]"
                  onClick={handlePhoneConfirmOtp}
                >
                  {t("Confirm")}
                </button>
              </div>
            </div>
          )}
          {step == 3 && (
            <div
              className={`rounded-[20px] lg:rounded-[64px] w-[520px] max-w-full mx-auto relative`}
            >
              <div className="flex flex-col justify-center items-center">
                <div className="mb-[19px]">
                  <IconSuccess />
                </div>
                <p className="text-center text-suzu-purple leading-[26px] lg:leading-10 lg:pb-3">
                  {t("title.verify_success")}
                </p>
              </div>
            </div>
          )}
          <button className="hidden" id="getotp"></button>
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  );
};
